<script>
  import ClipboardCopy from "../ClipboardCopy.svelte"

  export let glyph

  $: css = glyph.css_content_entity
  $: html = glyph.html_decimal_entity
</script>

<div>
  <h3>{glyph.description}</h3>
  <dl>
    <dt>Unicode Decimal</dt>
    <dd>{glyph.unicode_decimal}</dd>
    <dt>CSS entity</dt>
    <dd>
      <ClipboardCopy label={css} value={css} underlined={false} />
    </dd>
    <dt>HTML entity</dt>
    <dd>
      <ClipboardCopy label={html} value={html} underlined={false} />
    </dd>
  </dl>
</div>

<style>
  div {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  dl {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 0.75em;
  }
</style>
